<sc-sub-title><sc-dictionary-label
dictionaryKey="tmc-yard.access.ui.entrance-leave-dialog.hints-title"></sc-dictionary-label></sc-sub-title>
<sc-content-spacer vertical></sc-content-spacer>
@if (checks == null || checks.length == 0) {
  <sc-no-data compact></sc-no-data>
}
@for (check of checks; track check; let i = $index) {
  <div>
    @if (i > 0) {
      <sc-content-spacer vertical></sc-content-spacer>
    }
    <div class="hint {{check.state}}">
      <sc-padding>
        <sc-flex>
          <sc-icon iconClass="{{getIconForState(check.state)}} fa-2x"></sc-icon>
          <sc-content-spacer></sc-content-spacer>
          <sc-dictionary-label [dictionaryKey]="check.nameDictionaryKey"></sc-dictionary-label>
        </sc-flex>
        @if (check.descriptionDictionaryKey) {
          <sc-content-spacer half></sc-content-spacer>
          <sc-hint-legacy>
            <sc-dictionary-label [dictionaryKey]="check.descriptionDictionaryKey"></sc-dictionary-label>
          </sc-hint-legacy>
        }
      </sc-padding>
    </div>
  </div>
}
